
import './seo-vars-macro.tag'
import './seo-vars-word-exclude.tag'
riot.tag2('seo-vars', '  <ul class="nav nav-tabs m-b-2">\n    <li class="active"><a data-toggle="tab" href="#seo-vars-macro">Макропеременные</a></li>\n    <li><a data-toggle="tab" href="#seo-vars-word-exclude">Слова исключения</a></li>\n  </ul>\n  <div class="tab-content">\n    <div class="tab-pane fade in active" id="seo-vars-macro">\n      <seo-vars-macro></seo-vars-macro>\n    </div>\n    <div class="tab-pane fade" id="seo-vars-word-exclude">\n      <seo-vars-word-exclude></seo-vars-word-exclude>\n    </div>\n  </div>\n', '', '', function(opts) {
});


// WEBPACK FOOTER //
// ./pages/settings/seo-vars/seo-vars.tag